import { createContext, useContext } from 'react';
var EMPTY_ARRAY = [];
var DEFAULT_CONTEXT = {
  autoConnect: false,
  connecting: false,
  connected: false,
  disconnecting: false,
  select: function select(_name) {
    console.error(constructMissingProviderErrorMessage('get', 'select'));
  },
  connect: function connect() {
    return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'connect')));
  },
  disconnect: function disconnect() {
    return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'disconnect')));
  },
  sendTransaction: function sendTransaction(_transaction, _connection, _options) {
    return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'sendTransaction')));
  },
  signTransaction: function signTransaction(_transaction) {
    return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'signTransaction')));
  },
  signAllTransactions: function signAllTransactions(_transaction) {
    return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'signAllTransactions')));
  },
  signMessage: function signMessage(_message) {
    return Promise.reject(console.error(constructMissingProviderErrorMessage('get', 'signMessage')));
  }
};
Object.defineProperty(DEFAULT_CONTEXT, 'wallets', {
  get: function get() {
    console.error(constructMissingProviderErrorMessage('read', 'wallets'));
    return EMPTY_ARRAY;
  }
});
Object.defineProperty(DEFAULT_CONTEXT, 'wallet', {
  get: function get() {
    console.error(constructMissingProviderErrorMessage('read', 'wallet'));
    return null;
  }
});
Object.defineProperty(DEFAULT_CONTEXT, 'publicKey', {
  get: function get() {
    console.error(constructMissingProviderErrorMessage('read', 'publicKey'));
    return null;
  }
});

function constructMissingProviderErrorMessage(action, valueName) {
  return 'You have tried to ' + " ".concat(action, " \"").concat(valueName, "\"") + ' on a WalletContext without providing one.' + ' Make sure to render a WalletProvider' + ' as an ancestor of the component that uses ' + 'WalletContext';
}

export var WalletContext = createContext(DEFAULT_CONTEXT);
export function useWallet() {
  return useContext(WalletContext);
}